import { render, staticRenderFns } from "./Comingsoon_rami.vue?vue&type=template&id=5e8432bc&scoped=true&"
import script from "./Comingsoon_rami.vue?vue&type=script&lang=js&"
export * from "./Comingsoon_rami.vue?vue&type=script&lang=js&"
import style0 from "./Comingsoon_rami.vue?vue&type=style&index=0&id=5e8432bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8432bc",
  null
  
)

export default component.exports